// NewCategory.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const NewAd = () => {
    const [name, setName] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [newImage, setNewImage] = useState(null);
    const [NewImageView, setNewImageView] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [subCategoryId, setSubCategoryId] = useState('');
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [link, setLink] = useState('');
    const [Title, setTitle] = useState('');
    const [Description, setDescription] = useState('');
    
    const [location, setLocation] = useState('');
    const [duration, setDuration] = useState('');
    const [startDate, setStartDate] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null); // Track the selected category

    const navigate = useNavigate();


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true)
                const token = JSON.parse(localStorage.getItem('token'));
                const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/categories`, {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'x-api-key': 'web-app',
                    },
                });
                const data = await response.json();
                setLoading(false)

                if (response.ok) {
                    setCategories(data.categories); // Assuming data is an array of categories
                } else {
                    toast.error('Failed to load categories.');
                }
            } catch (err) {
                setLoading(false)

                console.error("Failed to fetch categories", err);
            }
        };

        fetchCategories();
    }, []);

    const handleCategoryChange = async (e) => {

        console.log("e", e.target)
        const categoryId = e.target.value;
        setSelectedCategory(categoryId)

    };




    const handleImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!validTypes.includes(file.type)) {
                toast.error('Please select a valid image file (jpeg, jpg, png).');
                return;
            }
            setNewImage(file); // Store the file object
            setNewImageView(URL.createObjectURL(event.target.files[0]));
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setError('')
        if ( !link) {
            toast.error('Please fill in all required fields.');
            return;
        }
        if (!newImage) {
            toast.error('Please select an image.');
            return;
        }
        setLoading(true);

        try {
            const token = JSON.parse(localStorage.getItem('token'));
            if (!token) {
                toast.error('You are not authenticated.');
                return;
            }

            const formData = new FormData();
            if(selectedCategory){
                formData.append('category_id', selectedCategory);
            }
            formData.append('link', link);
            formData.append('title', Title);
            formData.append('description', Description);
            formData.append('images[]', newImage);
            const response = await fetch(baseUrl + '/categories/category-images', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();
            console.log("data", data)
            if (response.ok) {
                toast.success('Ad added successfully');
                navigate('/ads');
            } else {
                if (data.errors) {
                    toast.error(data.errors[0].message);
                }
            }
        } catch (err) {
            console.log("err", err)
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ width: '100%', justifyContent: 'center' }}>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}


            <h2 style={{ color: "#000", textAlign: 'center' }}>New slider image</h2>
            <div className="new-category-container">
                <div className="new-category" style={{ width: "80%", justifyContent: "center", alignContent: "center", alignItems: "center" }}>

                    <div className="new-form-group">

                        <div className="dropdown-container" style={{ width: '70%', marginBottom: '10px', alignSelf: 'center', marginTop: "10px" }}>
                            <select
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    fontSize: '18px',
                                    padding: '0 10px', // Horizontal padding for the select box
                                    appearance: 'none', // Hides the default arrow
                                    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E") no-repeat right 20px center`, // Custom arrow
                                    backgroundSize: '20px', // Adjust the size of the arrow
                                    backgroundColor: '#fff', // Background color of the select
                                    borderRadius: '10px', // Optional: Add border-radius for a rounded look
                                    border: '1px solid #ccc', // Optional: Border style
                                    color: selectedCategory ? '#000' : '#a9a9a9',

                                }}
                                onChange={handleCategoryChange}
                                value={selectedCategory || ''}
                            >
                                <option value="" disabled>Select a Category</option>
                                {categories.map((category) => (
                                    <option key={category.id} value={category.id} style={{ color: '#000' }}>
                                        {category.name.en}{'-'}{category.name.ar}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>




                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: link ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Link'
                            type="text"
                            id="link"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            required
                        />
                    </div>


                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: link ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='title'
                            type="text"
                            id="title"
                            value={Title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>

                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: link ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Description'
                            type="text"
                            id="Description"
                            value={Description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                        />
                    </div>



                    <div className="new-form-group">
                        <label htmlFor="imageUrl">Image</label>
                        <div className="image-preview">
                            <label htmlFor="imageUpload" className="upload-label">
                                {NewImageView ? (
                                    <img src={NewImageView} alt="Category" className="newcategory-image" />
                                ) : (
                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                )}
                            </label>
                            <input
                                required
                                type="file"
                                id="imageUpload"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>

                    <div className="form-buttons">
                        <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
                        <button onClick={() => navigate('/Ads')} style={{ backgroundColor: "#000" }}>Cancel</button>
                    </div>

                    <div style={{ height: '50px' }}></div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default NewAd;
